import {DefaultTheme} from "styled-components"

export const MainThm: DefaultTheme = {
    // ${({theme}) => theme.color.ColorName};
    col: {
        mainCol:"#06101c",
        subCol:"#ffdd00",
        white:"rgb(248, 248, 248)",
        black000:"#000",       
        bgCol:"#06101c",
        mainFont:"Noto Sans KR",
        mainFontCol:"inherit",
        subFontCol:"#999",
        subFont:"Noto Sans KR",
    }
}
